import React from 'react';

function Logo() {
  return (
    <img alt="logo" src="assets/images/logos/purple.png" style={{ width: 200, height: 135 }} />
  );
}

export default Logo;
